export default {"src":"/_next/static/media/mongodb.03c79db5.svg","height":278,"width":1102,"blurWidth":0,"blurHeight":0};